import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserSession } from '../components/UserSession';

function Callback() {
  const navigate = useNavigate();
  const { setToken } = useUserSession();
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    if (token) setToken(token);
    window.setTimeout(() => {
      navigate(token ? searchParams.get('state') ?? '/home' : '/', {
        replace: true,
      });
    }, 500);
  }, [navigate, setToken]);

  return <div />;
}

export default Callback;
